import React from "react";

import styles from "./AboutCompanyBackground.module.scss";

const AboutCompanyBackground = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.firstColor}></div>
      <div className={styles.secondColor}></div>
    </div>
  );
};

export default AboutCompanyBackground;
